module.exports = __webpack_public_path__ + "img/heart.224ed153.svg";